import { render, staticRenderFns } from "./GoToParentPortal.vue?vue&type=template&id=1ff180f4&scoped=true"
import script from "./GoToParentPortal.vue?vue&type=script&lang=js"
export * from "./GoToParentPortal.vue?vue&type=script&lang=js"
import style0 from "./GoToParentPortal.vue?vue&type=style&index=0&id=1ff180f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff180f4",
  null
  
)

export default component.exports